import { apolloClient } from '@/plugins/vue-apollo';
import {
  createMaterialAMSA,
  updateMaterialAMSA,
  INSERT_WORKFLOW_STEP_LOG,
  UPDATE_WORKFLOW_STEP_LOG,
} from '@/store/graphql/mutations/amsaCataloger';
import {
  GET_DROPDOWN_INFORMATION_AMSA,
  GET_MANUFACTURER,
  GET_FAMILY_AMSA,
  GET_CLASE_AMSA,
  GET_TEMPLATE_AMSA,
  GET_AMSA_MATERIALS,
  GET_AMSA_MATERIAL_BY_ID,
} from '@/store/graphql/queries/amsaCataloger';
import { Notification as notify } from 'element-ui';

const amsaMaterials = {
  namespaced: true,
  state: {
    amsaMaterials: [],
    segmentoDropdown: [],
    familiaDropdown: [],
    claseDropdown: [],
    templateDropdown: [],
    featurePlanningNeedsDropdown: [],
    materialCarryingGroupDropdown: [],
    articlesGroupDropdown: [],
    sapCodeManufactureDropdown: [],
    measureBaseUnitDropdown: [],
    frequencyChangeDropdown: [],
    purchaseGroupDropdown: [],
    warehouseDropdown: [],
    logisticsCenterDropdown: [],
    ratingCategoryDropdown: [],
    materialTypeDropdown: [],
    amsaMaterialsAllRequests: [],
    idmAMSADropdown: [],
    editMaterialRequestID: null,
    editMaterialWorkflowStepId: null,
    manufacturerForAttributes: [],
    logsMaterialRequest: null,
    arrayKeyWordsCAT4MROSearch: null,
  },
  actions: {
    async createMaterialAMSA({ state, dispatch, rootState }, data) {
      try {
        /* eslint-disable */
        data.last_action = rootState.materials.workflowActions[0].id; // Creación Workflow Action
        data.step_id = rootState.materials.arrayWorkFlowSteps[1].id; // workflow_step --> Creación
        delete data.comment;
        data.search_statistic = state.arrayKeyWordsCAT4MROSearch.join(", ").toString();
        /* eslint-enable */
        const insertMutation = {
          mutation: createMaterialAMSA,
          variables: {
            data,
          },
        };
        const result = await apolloClient.mutate(insertMutation);
        const variablesForLog = {
          action_id: rootState.materials.workflowActions[0].id, // Creación Workflow Action
          actual_step: data.step_id,
          before_step: data.step_id,
          comment: null,
          material_creation_id: result.data.insert_mdm_amsa_material_creation.returning[0].id,
          workflow_id: rootState.materials.creationWorkflowID,
          action_date: new Date().toISOString(),
        };
        dispatch('workflowStepLogCreate', variablesForLog);
        notify({
          type: "success",
          title: 'Éxito',
          message: 'La solicitud ha sido creada.',
        });
        return result;
      } catch (error) {
        window.console.error('Error on createMaterialAMSA:', error, '\nVariables:', data);
        notify.error({
          title: 'Error',
          message: 'Error al crear la solicitud del material',
        });
        return null;
      }
    },
    async updateMaterialAMSA({ state, dispatch, rootState }, data) {
      try {
        const localData = { ...data };
        delete localData.id;
        delete localData.comment;
        delete localData.doNotAddLog;
        localData.updated_at = new Date().toISOString();
        const insertMutation = {
          mutation: updateMaterialAMSA,
          variables: {
            data: localData,
            id: data.id,
          },
        };
        const result = await apolloClient.mutate(insertMutation);
        // This is where notification should come
        if (data.doNotAddLog) return result;
        let lastLogOfWorkFlowStep = null;
        if (state.logsMaterialRequest && state.logsMaterialRequest.length > 0) lastLogOfWorkFlowStep = state.logsMaterialRequest[state.logsMaterialRequest.length - 1];
        if (!lastLogOfWorkFlowStep) return null;
        if (lastLogOfWorkFlowStep.endAction) { // rootState.materials.arrayWorkFlowSteps[1].id: workflow_step --> Creación
          const variables = {
            action_id: localData.last_action,
            actual_step: localData.step_id,
            before_step: lastLogOfWorkFlowStep.actualStep,
            comment: data.comment,
            material_creation_id: result.data.update_mdm_amsa_material_creation_by_pk.id,
            workflow_id: rootState.materials.creationWorkflowID,
            end_action: new Date().toISOString(),
            action_date: lastLogOfWorkFlowStep.endAction,
          };
          dispatch("workflowStepLogCreate", variables);
        } else {
          window.console.log('Success, estas cerrando log creado');
          const variables = {
            id: state.logsMaterialRequest[0].id,
            comment: data.comment,
            end_action: new Date().toISOString(),
          };
          dispatch("workflowStepLogUpdate", variables);
        }
        return result;
      } catch (error) {
        notify.error({
          title: 'Error',
          message: 'Lo sentimos, no se pudo realizar la acción deseada.',
        });
        window.console.error('Error on createMaterialAMSA:', error, '\nVariables:', data);
        return null;
      }
    },
    async sendMaterialAMSA({ dispatch, rootState }, data) {
      const localData = { ...data };
      localData.step_id = rootState.materials.arrayWorkFlowSteps[2].id; // workflow_step --> Liberador AMSA
      localData.last_action = rootState.materials.workflowActions[0].id; // Creación Workflow Action
      const result = await dispatch('updateMaterialAMSA', localData);
      if (!result || result.error) return null;
      notify({
        type: "success",
        title: 'Éxito',
        message: 'La solicitud ha sido enviada.',
      });
      return result;
    },
    async approveMaterialAMSA({ dispatch, rootState }, { data, workflowStep }) {
      const localData = { ...data };
      if (workflowStep.stepApproval === 0) return null; // Retorna porque se está en la última etapa
      localData.step_id = workflowStep.stepApproval;
      const nextWFStep = rootState.materials.arrayWorkFlowSteps.find(element => element.id === workflowStep.stepApproval);
      let indexWFAction = 1; // Aprobado Workflow Action
      if (nextWFStep.stepApproval === 0) indexWFAction = 4; // Integración Workflow Action
      localData.last_action = rootState.materials.workflowActions[indexWFAction].id;
      const result = await dispatch('updateMaterialAMSA', localData);
      if (!result || result.error) return null;
      notify({
        type: "success",
        title: 'Éxito',
        message: 'La solicitud ha sido enviada.',
      });
      return result;
    },
    async rejectMaterialAMSA({ dispatch, rootState }, { data, workflowStep }) {
      const localData = { ...data };
      if (workflowStep.stepApproval === 0) return null; // Retorna porque se está en la última etapa
      localData.step_id = workflowStep.stepReject;
      localData.last_action = rootState.materials.workflowActions[2].id; // Rechazado Workflow Action
      const result = await dispatch('updateMaterialAMSA', localData);
      if (!result || result.error) return null;
      notify({
        type: "success",
        title: 'Éxito',
        message: 'La solicitud ha sido enviada.',
      });
      return result;
    },
    async cancelMaterialAMSA({ dispatch, rootState }, data) {
      const localData = { ...data };
      localData.step_id = rootState.materials.arrayWorkFlowSteps[0].id; // workflow_step --> Cancelada
      localData.last_action = rootState.materials.workflowActions[3].id; // Cancelado Workflow Action
      const result = await dispatch('updateMaterialAMSA', localData);
      if (!result || result.error) return null;
      notify({
        type: "success",
        title: 'Éxito',
        message: 'La solicitud ha sido enviada.',
      });
      return result;
    },
    async GET_DROPDOWN_INFORMATION_AMSA({ state }) {
      try {
        const searchQuery = {
          query: GET_DROPDOWN_INFORMATION_AMSA,
        };
        const result = await apolloClient.query(searchQuery);
        // Tab solicitante
        state.warehouseDropdown = result.data.Warehouse;
        state.ratingCategoryDropdown = result.data.RatingCategory;
        state.logisticsCenterDropdown = result.data.LogisticsCenter;
        state.frequencyChangeDropdown = result.data.FrequencyChange; // anual consumption
        state.articlesGroupDropdown = result.data.ArticlesGroup;
        state.purchaseGroupDropdown = result.data.PurchaseGroup;
        state.materialCarryingGroupDropdown = result.data.MaterialCarryingGroup; // material_handling_group_id (al seleccionado)
        state.materialTypeDropdown = result.data.MaterialType;
        state.measureBaseUnitDropdown = result.data.MeasureBaseUnit;
        state.segmentoDropdown = result.data.segmentos;
        state.idmAMSADropdown = result.data.idmAMSA;
        // Tab Catalogador
        state.featurePlanningNeeds = result.data.FeaturePlanningNeeds;
        return result;
      } catch (error) {
        window.console.error('Error on GET_DROPDOWN_INFORMATION_AMSA:', error);
        return null;
      }
    },
    async GET_MANUFACTURER({ state }, variables) {
      try {
        const commingFromTemplateOEM = variables.setManFromAttr;
        // eslint-disable-next-line
        delete variables.setManFromAttr;
        const searchQuery = {
          query: GET_MANUFACTURER,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        if (commingFromTemplateOEM) state.manufacturerForAttributes = result.data.SAPCodeManufacture;
        else state.sapCodeManufactureDropdown = result.data.SAPCodeManufacture; // Al seleccionar uno se autocompletan 3 campos: (Formato: propiedad_del_valor_Seleccionado -> nombre_de_campo_autocompletado_de_material_creation_de_amsa) ----> short_name -> manufacturer_abbreviation, code -> sap_manufacturer_code, id -> manufacturer_name (cómo string)
        return result.data.SAPCodeManufacture;
      } catch (error) {
        window.console.error('Error on GET_MANUFACTURER:', error);
        return null;
      }
    },
    async GET_FAMILY_AMSA({ state }, variables) {
      try {
        const searchQuery = {
          query: GET_FAMILY_AMSA,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        state.familiaDropdown = result.data.familia;
        return result.data.familia;
      } catch (error) {
        window.console.error('Error on GET_FAMILY_AMSA:', error);
        return null;
      }
    },
    async GET_CLASE_AMSA({ state }, variables) {
      try {
        const searchQuery = {
          query: GET_CLASE_AMSA,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        state.claseDropdown = result.data.clase;
        return result;
      } catch (error) {
        window.console.error('Error on GET_CLASE_AMSA:', error);
        return null;
      }
    },
    async GET_TEMPLATE_AMSA({ state }, variables) {
      try {
        const searchQuery = {
          query: GET_TEMPLATE_AMSA,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        state.templateDropdown = result.data.template;
        return result;
      } catch (error) {
        window.console.error('Error on GET_TEMPLATE_AMSA:', error);
        return null;
      }
    },
    async GET_AMSA_MATERIALS({ state }) {
      try {
        const searchQuery = {
          query: GET_AMSA_MATERIALS,
          fetchPolicy: 'network-only',
        };
        const result = await apolloClient.query(searchQuery);
        state.amsaMaterialsAllRequests = result.data.getAllAMSAMaterials;
        return result;
      } catch (error) {
        window.console.error('Error on GET_AMSA_MATERIALS:', error);
        return null;
      }
    },
    async GET_AMSA_MATERIAL_BY_ID({ state }, variables) {
      try {
        const searchQuery = {
          query: GET_AMSA_MATERIAL_BY_ID,
          variables,
          fetchPolicy: 'network-only',
        };
        const result = await apolloClient.query(searchQuery);
        state.editMaterialRequestID = null;
        return result.data;
      } catch (error) {
        window.console.error('Error on GET_AMSA_MATERIAL_BY_ID:', error);
        return null;
      }
    },
    workflowStepLogCreate(state, variables) {
      try {
        const insertMutation = {
          mutation: INSERT_WORKFLOW_STEP_LOG,
          variables,
        };
        apolloClient.mutate(insertMutation);
      } catch (error) {
        window.console.error("Error on create log: ", error);
      }
    },
    workflowStepLogUpdate(state, variables) {
      try {
        const insertMutation = {
          mutation: UPDATE_WORKFLOW_STEP_LOG,
          variables,
        };
        apolloClient.mutate(insertMutation);
      } catch (error) {
        window.console.error("Error on update log: ", error);
      }
    },
  },
  mutations: {
    SET_MATERIAL_REQUEST_ID(state, id) {
      state.editMaterialRequestID = id;
    },
    SET_EDIT_MATERIAL_WORKFLOW_STEP_ID(state, editMaterialWorkflowStepId) {
      state.editMaterialWorkflowStepId = editMaterialWorkflowStepId;
    },
    SET_LOGS_MATERIAL_REQUEST(state, logsMaterialRequest) {
      state.logsMaterialRequest = logsMaterialRequest;
    },
    SET_ARRAY_KEYWORDS_CAT4MRO_SEARCH(state, arrayKeyWordsSearch) {
      state.arrayKeyWordsCAT4MROSearch = arrayKeyWordsSearch;
    },
  },
};

export default amsaMaterials;



// WEBPACK FOOTER //
// ./src/store/modules/cataloger/amsaMaterials.js